import { Component, Directive, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DTFHomepageService } from '../dtfhomepage/dtfhomepage.service';
import { AuthorizationService } from '../authorization/authorization.service';
import { WindowRef } from '../../utils/window';
import { TranslateService } from '@ngx-translate/core';
import { Banner } from '../../shared/models/banner';
import { TranslateUtil } from '../../utils/translate-util';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { AccoutDetailsResponse } from '../../shared/models/accountDetailsResponse';
import { InvoiceResponse } from '../../shared/invoiceResponse';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { animate, state, style, transition, trigger } from '@angular/animations';
import JSZip from 'jszip/dist/jszip';
import * as FileSaver from 'file-saver';
import { InvoiceFileData } from '../../shared/invoiceFileData';
import {InvoiceList} from '../../shared/invoiceList';
import {SelectionModel} from '@angular/cdk/collections';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatRadioModule } from '@angular/material/radio';
import { SharedTranslateModule } from '../../utils/sharedTranslateModule';
import { SessionTimeoutComponent } from '../sessionTimeout/sessionTimeout.component';
export enum ToggleEnum { //used for mat toggle
  Option1,
  Option2,
  Option3,
  Option4,
  Option5,
  Option6
}

@Component({
    selector: 'div.dtf-admininvoicepage',
    imports: [SharedTranslateModule,
        MatPaginator, MatSort, MatSortModule, MatTableModule,SessionTimeoutComponent, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatIconModule, MatTooltipModule, MatDatepickerModule, MatNativeDateModule, MatRadioModule
    ],
    templateUrl: './admininvoice.component.html',
    providers: [],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ]
})
export class AdminInvoiceComponent implements OnInit {
  title = 'Content Section of the Page';
  router: Router;
  path = '';
  loginRedirect = '';
  accountRedirect = '';
  token: string;
  brandId: string;
  loginAttempt = false;
  isLoginattempt = '';
  countryFlag: string;
  langFlag: string;
  currentCountry: string;
  isCanadaPortal = false;
  usUrl: string;
  caUrl: string;
  azURL: string;
  invoiceAccount: string;
  agentview: string;
  agentId: string;
  bodyLoaded = false;
  dbLoaded = false;
  isFrench = false;
  dbData: any;
  public alerts: Banner;
  toggleOpen: any;
  displayValue: string;
  invoiceList: InvoiceList[];
  invoiceObj : InvoiceList;
statementPeriod : string;
  pdfNames = [];
  xlsxNames = [];
  pdfByteArrays = [];
  xlsxByteArrays = [];
  isPdf=false;
  recAccCount = '';
  totalDue = '';
  ciamId = sessionStorage.getItem('loginID');
  // statementPeriod = sessionStorage.getItem();
  ccanId = '';
  showValue : string;
  dateRange = '' ;
  contractNumber: string;
  customerNumber: string;
  invoiceNumber : string;
  accountDetailsRes: AccoutDetailsResponse[];
  invoiceRes: InvoiceResponse[];
  invoiceFileData: InvoiceFileData[];
  invoiceNumberList: string[];
  base64data: string;
  pdfname: string;
  xlsxname: string;
  loanAccounts = false;
  InvoiceFound = false;
  InvoiceErrorDesc = '';
  invoiceRequest: any = {};
  iconRequest: any = {};
  dateRangeStart :string | Date ='';
  dateRangeEnd :string | Date = '' ;
  PDFBool = false;
  XLSXBool = false;
  selectedAllFlag = false;
  invoiceLoaded = true;

  selectedMonth: string = '';
  startDate: string = '';
  endDate: string = '';
  selectedDateRange: string = '';
  statementMonths: { key: string, value: string }[] = [];
  minDate: Date;
  currentDate: Date;
  monthListArray = [
    { month: '1', monthAsString: 'January' },
    { month: '2', monthAsString: 'February' },
    { month: '3', monthAsString: 'March' },
    { month: '4', monthAsString: 'April' },
    { month: '5', monthAsString: 'May' },
    { month: '6', monthAsString: 'June' },
    { month: '7', monthAsString: 'July' },
    { month: '8', monthAsString: 'August' },
    { month: '9', monthAsString: 'September' },
    { month: '10', monthAsString: 'October' },
    { month: '11', monthAsString: 'November' },
    { month: '12', monthAsString: 'December' },
  ];
  

   //used for mat-toggle
   toggleEnum = ToggleEnum;
   selectedState = ToggleEnum.Option6;
 
   // Table columns
   initColumns: any[] = [
    {
      name: 'select',
      display: '',
      displayMobile: '',
      displayFR: '',
      dispFormat: ''
    },{
     name: 'contractNumber',
     display: 'Contract',
     displayMobile: 'Contract',
     displayFR: 'Contracter',
     dispFormat: ''
   },
 
   {
     name: 'consolidationNumber',
     display: 'Customer Number',
     displayMobile: 'Billing Num',
     displayFR: 'Numéro de facturation',
     dispFormat: 'tooltip'
   },
  //  {
  //    name: 'dba_fao_billingAdd',
  //    display: 'Address',
  //    displayMobile: 'Address',
  //    displayFR: 'Adresse',
  //    dispFormat: ''
  //  },
   {
     name: 'invoiceNumber',
     display: 'Invoice Number',
     displayMobile: 'Invoice Num',
     displayFR: 'Numéro de facture',
     dispFormat: ''
   },
  //  {
  //    name: 'invoiceMonth',
  //    display: 'Invoice Month',
  //    displayMobile: 'Invoice Month',
  //    displayFR: 'Mois de facturation',
  //    dispFormat: ''
  //  },
   {
     name: 'invoiceDueDate',
     display: 'Due Date',
     displayMobile: 'Due Date',
     displayFR: 'Date',
     dispFormat: ''
   },
  //  {
  //    name: 'dynamicLease',
  //    display: 'Dynamic Lease',
  //    displayFR: '',
  //    dispFormat: ''
  //  },
   {
     name: 'viewInvoice',
     display: 'View Invoice',
     displayMobile: 'View Invoice',
     displayFR: 'Voir la facture',
     dispFormat: 'img'
   }
   ];
   displayedColumns: any[] = this.initColumns.map(col => col.name);
 
   filterActive = false;
   filter = false;
   rowCount = 0;
   value = '';
 
 
   dataSource: MatTableDataSource<InvoiceResponse>;
   selection = new SelectionModel<InvoiceResponse>(true, []);
 
   @ViewChild(MatPaginator) paginator: MatPaginator;
   @ViewChild(MatSort) sort: MatSort;
 
 
   constructor(router: Router, private dtfhomepageService: DTFHomepageService, public auth: AuthorizationService,
     private _window: WindowRef, public translate: TranslateService, public translateUtil: TranslateUtil
 
   ) {
     this.router = router;
     this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
     this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
     this.invoiceRes = [];
     this.invoiceList= [];
     this.dataSource = new MatTableDataSource(this.invoiceRes);
   }
 
   ngAfterViewInit() {
  }

  applyFilter(event: Event) {
    this.selectedState = undefined; //removes toggled mat-toggle
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.rowCount = this.dataSource.filteredData.length;
  }

  ngOnInit() {
    this.agentview = sessionStorage.getItem('agentview');
    this.agentId = sessionStorage.getItem('agentID');
    const language = (window as any).mbfs.language;
    const country = (window as any).mbfs.country;
    this.countryFlag = country;
    this.langFlag = language;
    this.brandId = sessionStorage.getItem('brandId');
    this.token = sessionStorage.getItem('ciamToken');

    this.minDate = new Date(new Date().getFullYear()-1, new Date().getMonth()-1, new Date().getDate());
    this.currentDate = new Date(new Date().getFullYear(), new Date().getMonth()+2, new Date().getDate());

    this.translateUtil.setCountryAndLangFromUIProp();
    this.translateUtil.getCurrentCountry().subscribe(val => {
      this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
      this.currentCountry = val;
    });
    this.isFrench = ('fr-CA' === language) ? true : false; //checks if language is french or english for Canada

    const dashBoardRequest = {
      ciamId: this.ciamId,
      ciamAZCode: this.token
    };
    this.getDashBoardDetails(dashBoardRequest);
    // this.getInvoice();
    //this.getAlerts();
    this.statementList()
   

  }
  anouncementMgsopen(e: any) {
    e.preventDefault();
    if (this.toggleOpen) {
      this.toggleOpen = false;
    } else {
      this.toggleOpen = true;
    }
  }

  // getAlerts() {
  //   this.dtfhomepageService.getAlerts().subscribe((res) => {
  //     for (var i = 0; i < res.length; i++) {
  //       if (this.currentCountry === 'CA') {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerName.indexOf((this.langFlag)) !== -1 &&
  //           res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'CA') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //       else {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'US') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //     }
  //   });
  // }

  // sessionStorageChecks(){
  //     this.invoiceRequest = {
  //        ciamId: this.ciamId,
  //        ciamAZCode: this.token,
  //        startDate: this.startDate,
  //        endDate: this.endDate,
  //        ccanId: this.customerNumber,
  //        invoiceNumber: this.invoiceNumber,
  //        contract: this.contractNumber
  //      };
  // }

  sessionStorageChecksType(filetype: string){
    let filterCheck = "";
    let statementPeriodSession = sessionStorage.getItem('statementPeriod');
    let startDateSession = sessionStorage.getItem('startDate');
    let endDateSession = sessionStorage.getItem('endDate');
    if(statementPeriodSession){ //sets Session Storage object as first option then clears
      this.displayValue = statementPeriodSession;
      this.statementPeriod = statementPeriodSession;
      sessionStorage.removeItem('statementPeriod');
      filterCheck ='statementSession';
    }
    else if(startDateSession && endDateSession){ //sets Session Storage object as first option then clears
      sessionStorage.removeItem('startDate');
      sessionStorage.removeItem('endDate');
      this.startDate = startDateSession; 
      this.endDate = endDateSession;
     // this.dateRangeStart=this.startDate;
      //this.dateRangeEnd=this.endDate;
      filterCheck = 'dateSession';
    }
    else if(this.startDate && this.endDate){
     //this.dateRangeStart=this.startDate;
      //this.dateRangeEnd=this.endDate;
      filterCheck = 'dateSession';
    }
    else if(this.displayValue){
      filterCheck ='statementSession';
      this.statementPeriod = this.displayValue;
    }

    if(filterCheck === 'statementSession'){
     this.invoiceRequest = {
        ciamId: this.ciamId,
        ciamAZCode: this.token,
        statementPeriod: this.statementPeriod,
        invoiceNumbers : this.invoiceNumberList,
        fileType: filetype
      };
    }
    else if(filterCheck === 'dateSession'){
      this.invoiceRequest = {
         ciamId: this.ciamId,
         ciamAZCode: this.token,
         startDate: this.startDate,
         endDate: this.endDate,
         invoiceNumbers : this.invoiceNumberList,
         fileType: filetype
       };
     }
  }

  sessionStorageChecksInvoiceList(filetype: string){
    let filterCheck = "";
    let statementPeriodSession = sessionStorage.getItem('statementPeriod');
    let startDateSession = sessionStorage.getItem('startDate');
    let endDateSession = sessionStorage.getItem('endDate');
    if(statementPeriodSession){ //sets Session Storage object as first option then clears
      this.displayValue = statementPeriodSession;
      this.statementPeriod = statementPeriodSession;
      sessionStorage.removeItem('statementPeriod');
      filterCheck ='statementSession';
    }
    else if(startDateSession && endDateSession){ //sets Session Storage object as first option then clears
      sessionStorage.removeItem('startDate');
      sessionStorage.removeItem('endDate');
      this.startDate = startDateSession; 
      this.endDate = endDateSession;
     // this.dateRangeStart=this.startDate;
      //this.dateRangeEnd=this.endDate;
      filterCheck = 'dateSession';
    }
    else if(this.startDate && this.endDate){
     //this.dateRangeStart=this.startDate;
      //this.dateRangeEnd=this.endDate;
      filterCheck = 'dateSession';
    }
    else if(this.displayValue){
      filterCheck ='statementSession';
      this.statementPeriod = this.displayValue;
    }

    if(filterCheck === 'statementSession'){
     this.invoiceRequest = {
        ciamId: this.ciamId,
        ciamAZCode: this.token,
        invoiceNumbers : this.invoiceNumberList,
        statementPeriod: this.statementPeriod,
        fileType: filetype
      };
    }
    else if(filterCheck === 'dateSession'){
      this.invoiceRequest = {
         ciamId: this.ciamId,
         ciamAZCode: this.token,
         invoiceNumbers : this.invoiceNumberList,
         startDate: this.startDate,
         endDate: this.endDate,
         fileType: filetype
       };
     }
  }

  getInvoice() {
  this.invoiceLoaded = false; //spinner
  this.InvoiceFound=false;
  this.invoiceRequest = {};

  if(!this.customerNumber){
    this.minDate = new Date(new Date().getFullYear()-2, new Date().getMonth(), new Date().getDate());
    this.currentDate = new Date(new Date().getFullYear(), new Date().getMonth()+2, new Date().getDate());

    this.startDate = this.formatString(this.minDate.toString());
    this.endDate = this.formatString(this.currentDate.toString());

  }

  this.invoiceRequest = {
    ciamId: this.ciamId,
    ciamAZCode: this.token,
    startDate: this.startDate,
    endDate: this.endDate,
    ccanId: this.customerNumber,
    invoiceNumber: this.invoiceNumber,
    contract: this.contractNumber
  };
      this.auth.fetchAdminInvoiceDetailsfromDB(this.invoiceRequest).subscribe(res => {
      this.invoiceList = [];
      this.invoiceRes = [];
      this.invoiceFileData = [];
      this.invoiceRes = res.viewInvoiceDetails;

      this.invoiceRes = res.viewInvoiceDetails.sort((a, b) => {
        return new Date(b.invoiceDueDate).getTime() - new Date(a.invoiceDueDate).getTime();
      });

      this.dataSource = new MatTableDataSource(this.invoiceRes);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.filterPredicate = function(data, filter: string): boolean {
        return data.contractNumber.toLowerCase().includes(filter) || data.invoiceNumber.toLowerCase().includes(filter);
      };
      this.rowCount = this.dataSource.filteredData.length;

      for (var i = 0; i < this.invoiceRes.length; i++) {
        if (this.invoiceRes[i].statusMessage === 'SUCCESS') {
          this.invoiceFileData=this.invoiceRes[i].invoiceFileData;
          if(this.invoiceFileData.length > 0){
            this.InvoiceFound = true;
          }
        }
      }
      if (!this.InvoiceFound) {
        this.translate.get('Errors.InvoiceError').subscribe((data: any) => {
          this.InvoiceErrorDesc = data;
        });
        setTimeout(() => {
          this.dbLoaded = true;
          this.filter = true;
          this.rowCount = this.dataSource.filteredData.length;
        }, 3000);  //3s
      }
      this.invoiceLoaded=true;
    });
  }

  onDownloadClick(filetype: string){
    this.invoiceLoaded = false; //spinner
    this.pdfByteArrays=[];
    this.pdfNames=[];
    this.xlsxByteArrays=[];
    this.xlsxNames=[];
    this.invoiceNumberList=[];

    this.InvoiceFound=false;
    this.invoiceRequest = {};
    this.checkToggleSelected(); //checks select Box


    if(this.selectedAllFlag){
      //Check via CCAN
      this.sessionStorageChecksType(filetype);
      this.auth.getInvoice(this.invoiceRequest).subscribe(res => {
        this.invoiceList = [];
        this.invoiceFileData = [];
        this.invoiceRes = [];
        this.invoiceRes = res.viewInvoiceDetails;
        for (var i = 0; i < res.viewInvoiceDetails.length; i++) {
          if (this.invoiceRes[i].statusMessage === 'SUCCESS') {
            this.invoiceFileData=this.invoiceRes[i].invoiceFileData;
            for (var j = 0; j < this.invoiceFileData.length; j++)  {
              this.InvoiceFound = true;
              this.invoiceObj = new InvoiceList;
                this.invoiceObj.fileType=this.invoiceFileData[j].fileType;
                this.invoiceObj.fileName=this.invoiceFileData[j].fileName;
                this.invoiceObj.contractNumber=this.invoiceRes[i].contractNumber;
                this.invoiceObj.encodedFile=this.invoiceFileData[j].encodedFile;
                this.invoiceList.push(this.invoiceObj);
            }
          }
        }
        for (var i = 0; i < this.invoiceList.length; i++) {
          if ((this.invoiceList[i].fileType === filetype) && filetype === '.pdf') {
            this.pdfByteArrays.push(this.invoiceList[i].encodedFile);
            this.pdfNames.push(this.invoiceList[i].fileName);
          }
          else if ((this.invoiceList[i].fileType === filetype) && filetype === '.xlsx') {
            this.xlsxByteArrays.push(this.invoiceList[i].encodedFile);
            this.xlsxNames.push(this.invoiceList[i].fileName);
          }
      }   

      if (this.pdfByteArrays.length + this.xlsxByteArrays.length > 1) { //Download list as Zip
        this.downloadZipType(filetype);
      }
      else if (this.pdfByteArrays.length + this.xlsxByteArrays.length === 1) {//Download Single PDF
        if(this.xlsxByteArrays.length === 1){
          this.isPdf=false;
        }
        else{
          this.isPdf=true;
        }
        this.getImage(this.isPdf);
      }
      this.invoiceLoaded=true;
    });
    }
    else{
      //check via invoice number List
        this.sessionStorageChecksInvoiceList(filetype);
        this.auth.fetchAdminEncodedInvoiceList(this.invoiceRequest).subscribe(res => {
          this.invoiceList = [];
          this.invoiceFileData = [];
          this.invoiceRes = [];
          this.invoiceRes = res.viewInvoiceDetails;
          for (var i = 0; i < res.viewInvoiceDetails.length; i++) {
            if (this.invoiceRes[i].statusMessage === 'SUCCESS') {
              this.invoiceFileData=this.invoiceRes[i].invoiceFileData;
              for (var j = 0; j < this.invoiceFileData.length; j++)  {
                this.InvoiceFound = true;
                this.invoiceObj = new InvoiceList;
                  this.invoiceObj.fileType=this.invoiceFileData[j].fileType;
                  this.invoiceObj.fileName=this.invoiceFileData[j].fileName;
                  this.invoiceObj.contractNumber=this.invoiceRes[i].contractNumber;
                  this.invoiceObj.encodedFile=this.invoiceFileData[j].encodedFile;
                  this.invoiceList.push(this.invoiceObj);
              }
            }
          }
  
          for (var i = 0; i < this.invoiceList.length; i++) {
            if ((this.invoiceList[i].fileType === filetype) && filetype === '.pdf') {
              this.pdfByteArrays.push(this.invoiceList[i].encodedFile);
              this.pdfNames.push(this.invoiceList[i].fileName);
            }
            else if ((this.invoiceList[i].fileType === filetype) && filetype === '.xlsx') {
              this.xlsxByteArrays.push(this.invoiceList[i].encodedFile);
              this.xlsxNames.push(this.invoiceList[i].fileName);
            }
        }   
  
        if (this.pdfByteArrays.length + this.xlsxByteArrays.length > 1) { //Download list as Zip
          this.downloadZipType(filetype);
        }
        else if (this.pdfByteArrays.length + this.xlsxByteArrays.length === 1) {//Download Single PDF
          if(this.xlsxByteArrays.length === 1){
            this.isPdf=false;
          }
          else{
            this.isPdf=true;
          }
          this.getImage(this.isPdf);
        }
        this.invoiceLoaded=true;
      });
    }

  }

  onIconClick(invoiceNumber: string, filetype: string){
    this.invoiceLoaded = false; //spinner
    this.pdfByteArrays=[];
    this.pdfNames=[];
    this.xlsxByteArrays=[];
    this.xlsxNames=[];

    this.iconRequest = {};
    this.iconRequest = {
      ciamId: this.ciamId,
      ciamAZCode: this.token,
      invoiceNumbers: [invoiceNumber],
      fileType: filetype
    };
    
    this.auth.fetchAdminEncodedInvoiceList(this.iconRequest).subscribe(res => {
      this.invoiceList = [];
      this.invoiceRes = [];
      this.invoiceRes = res.viewInvoiceDetails;
      for (var i = 0; i < this.invoiceRes.length; i++) {
        if (this.invoiceRes[i].statusMessage === 'SUCCESS') {
          this.invoiceFileData=this.invoiceRes[i].invoiceFileData;
          for (var j = 0; j < this.invoiceFileData.length; j++)  {
            this.InvoiceFound = true;
            this.invoiceObj = new InvoiceList;
              this.invoiceObj.fileType=this.invoiceFileData[j].fileType;
              this.invoiceObj.fileName=this.invoiceFileData[j].fileName;
              this.invoiceObj.contractNumber=this.invoiceRes[i].contractNumber;
              this.invoiceObj.encodedFile=this.invoiceFileData[j].encodedFile;
              this.invoiceList.push(this.invoiceObj);
          }
        }
      }

      for (var i = 0; i < this.invoiceList.length; i++) {
          if ((this.invoiceList[i].fileType === filetype) && filetype === '.pdf') {
            this.pdfByteArrays.push(this.invoiceList[i].encodedFile);
            this.pdfNames.push(this.invoiceList[i].fileName);
          }
          else if ((this.invoiceList[i].fileType === filetype) && filetype === '.xlsx') {
            this.xlsxByteArrays.push(this.invoiceList[i].encodedFile);
            this.xlsxNames.push(this.invoiceList[i].fileName);
          }
      }   

    if (this.pdfByteArrays.length + this.xlsxByteArrays.length > 1) { //Download list as Zip
      this.downloadZip();
    }
    else if (this.pdfByteArrays.length + this.xlsxByteArrays.length === 1) {//Download Single PDF
      if(this.xlsxByteArrays.length === 1){
        this.isPdf=false;
      }
      else{
        this.isPdf=true;
      }
      this.getImage(this.isPdf);
    }
    this.invoiceLoaded=true;
    });
  }

  getDashBoardDetails(dashBoardRequest) {
    this.auth.getDashBoardDetails(dashBoardRequest).subscribe(res => {
      this.recAccCount = res.recAccCount;
      this.totalDue = res.totalDue;
      if (this.totalDue.includes("-")) {
        this.totalDue = "0.00";
      }
    });
  }

  public b64toBlob(b64Data, contentType) {
    contentType = contentType || '';
    let sliceSize = 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  getImage(isPdf: boolean) {
    if(!isPdf){
      //XLSX code
      this.pdfname = this.xlsxNames[0];
      this.base64data = this.xlsxByteArrays[0];
      var mediaType="data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
      var a = document.createElement('a');
      a.href = mediaType+this.base64data;
      a.download = String(this.pdfname);
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    }
    else{
      //PDF code
      this.pdfname = this.pdfNames[0];
      this.base64data = this.pdfByteArrays[0];
      var blob = this.b64toBlob(this.base64data, "application/pdf");
      let a = document.createElement("a");
      document.body.appendChild(a);
      var url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = String(this.pdfname);
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    }
  }

  downloadZip(){ //For Icon Download
    var zip=new JSZip();
    // var pdf= zip.folder('pdfs');
    this.pdfByteArrays.forEach((value,i)=>{
      zip.file(this.pdfNames[i] +'.pdf',value,{base64:true});
    });
    
    // var invoice_xlsx=zip.folder('invoice_xlsx');
    this.xlsxByteArrays.forEach((value,i)=>{
      zip.file(this.xlsxNames[i]+'.xlsx',value,{base64:true});
    });
    
    zip.generateAsync({type:'blob'}).then(function(content){
    FileSaver.saveAs(content,'invoice.zip');
    });
    } 


    downloadZipType(filetype: string){ //For Download All
      var zip=new JSZip();
      if(filetype==='.pdf'){
        // var pdf= zip.folder('pdfs');
        this.pdfByteArrays.forEach((value,i)=>{
          zip.file(this.pdfNames[i] +'.pdf',value,{base64:true});
          });
      }
      if(filetype==='.xlsx'){
        // var invoice_xlsx=zip.folder('invoice_xlsx');
        this.xlsxByteArrays.forEach((value,i)=>{
          zip.file(this.xlsxNames[i]+'.xlsx',value,{base64:true});
        });
      } 
      zip.generateAsync({type:'blob'}).then(function(content){
      FileSaver.saveAs(content,'invoice.zip');
      });
    } 
  
     statementList() {
      let iterdate = new Date(new Date().getFullYear() - 1, new Date().getMonth() , new Date().getDate());
      while (this.currentDate.getTime() >= iterdate.getTime()) {
        let current_month = iterdate.getMonth() + 1; // 9
        let current_year = iterdate.getFullYear(); //2022
        let stamentmonth = `${current_month}/01/${current_year}`; // 9/01/2022
        iterdate.setMonth(iterdate.getMonth() + 1);//incrementing the month of iterateor date
        this.statementMonths.push({
          key: stamentmonth,
          value: this.getMonthData(stamentmonth)
        }); //pushes statemetn period to the list
      }
      this.statementMonths = this.statementMonths.reverse();
    }
    getMonthData(monthData: string): string {
      if (monthData !== '') {
  
        const commaSeparated = monthData.split('/'); // ['9' , '01' , '2022']
        return `${this.monthListArray.find(x => x.month === commaSeparated[0]).monthAsString} ${commaSeparated[2]}`; //September, 2022
      }
      return '';
    }


  
    dateRangeChange() {
      this.displayValue ='';
      this.startDate='';
      this.endDate = '';
      this.startDate = this.formatString(this.dateRangeStart.toString());
      this.endDate = this.formatString(this.dateRangeEnd.toString());
      //this.getInvoice();
      if (new Date(this.startDate) <= new Date(this.endDate)){ 
        this.getInvoice();
    }
     }
 
     onStatementChange(){
      this.dateRangeStart='';
      this.dateRangeEnd='';
      this.startDate='';
      this.endDate = '';
      this.getInvoice();
     }

    clearEndDate($event){
      this.dateRangeEnd='';
      this.endDate = '';

      }

      clearAll($event){
        this.startDate = '';
        this.endDate = '';
        this.ccanId = '';
        this.invoiceNumber = '';
        this.customerNumber = '';
        this.contractNumber = '';
        this.dateRangeEnd='';
        this.dateRangeStart = '';
        }

     formatString(date: string): string {
      let newDate = new Date(date);
        let day: string = newDate.getDate().toString();
        day = +day < 10 ? '0' + day : day;
        let month: string = (newDate.getMonth() + 1).toString();
        month = +month < 10 ? '0' + month : month;
        let year = newDate.getFullYear();
        return `${month}/${day}/${year}`;
    }
     
    booleanReset(){
      this.PDFBool = false;
      this.XLSXBool = false;
    }

    booleanCheck(type: string){
      if(type ==='.pdf'){
        this.PDFBool = true;
      }
      else if(type ==='.xlsx'){
        this.XLSXBool = true;
      }
    }
    isAllSelected() {
      const numSelected = this.selection.selected.length;
      const numRows = this.dataSource.data.length;
      return numSelected === numRows;
    }
  
    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
      this.isAllSelected() ?
          this.selection.clear() :
          this.dataSource.data.forEach(row => this.selection.select(row));
    }

   checkToggleSelected(){
    this.invoiceNumberList = [];
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    if(numSelected === numRows){
      this.selectedAllFlag = true; 
      for (var i = 0; i < this.selection.selected.length; i++) {
        this.invoiceNumberList.push(this.selection.selected[i].invoiceNumber);
      }
    }
    else{
      this.selectedAllFlag = false;   
      for (var i = 0; i < this.selection.selected.length; i++) {
        this.invoiceNumberList.push(this.selection.selected[i].invoiceNumber);
      }
    }
   }
    
    }




  
